module.exports = __webpack_public_path__ + "static/media/waves.59db8c56.webp";